import { useNavigate } from "react-router-dom";
import { Button } from "../shared";

export const CalendarOnboardingModal = ({ onDismiss }) => {
  const navigate = useNavigate();

  const handleCreateProject = () => {
    navigate("/projects?prompt_project_create=1");
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={onDismiss}>
      <div className="bg-white rounded-2xl p-8 max-w-md text-center shadow-2xl mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="w-16 h-16 bg-secondary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-secondary-dark"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-primary mb-2">
          Get Started with Your Timeline
        </h2>

        <p className="text-mediumgrey mb-6">
          To use the calendar view, you need at least one project with tasks.
          Create a project first, then add tasks with start and due dates.
        </p>

        <div className="flex flex-col gap-3">
          <Button
            onClick={handleCreateProject}
            className="w-full"
            variant="filled"
            color="secondary"
          >
            Create Your First Project
          </Button>

          <Button
            onClick={onDismiss}
            className="w-full"
            variant="transparent"
            color="primary"
          >
            I&apos;ll do this later
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CalendarOnboardingModal;
